<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        width="100%"
        outlined
        min-height="180px"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Jurado:</h3>
          </v-col>

          <v-col cols="12" xl="8" md="8" sm="8" xs="12">
            <v-text-field
              :maxlength="75"
              :counter="75"
              :rules="[v => (v || '' ).length <= 74 || 'El nombre no debe tener mas de 75 caracteres']"
              ref="name"
              v-model="name"
              outlined
              label="Nombre"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="4" xs="12">
            <v-select
                :items="countries"
                label="País"
                v-model="country_id"
                name="countries"
                :item-text="'name'"
                :item-value="'id'"
                outlined
              ></v-select>
          </v-col>

          <v-col cols="12">
            <v-text-field
              ref="edition.last_position"
              v-model="last_position"
              outlined
              :maxlength="100"
              :counter="100"
              :rules="[v => (v || '' ).length <= 99 || 'El ultimo cargo no debe tener mas de 100 caracteres']"
              label="Ultimo cargo"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-textarea
              outlined
              :maxlength="600"
              :counter="600"
              :rules="[v => (v || '' ).length <= 599 || 'La descripción no debe tener mas de 600 caracteres']"
              ref="description"
              v-model="description"
              name="description"
              label="Descripción"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-sheet>

      <v-sheet
        class="mt-4"
        width="100%"
        outlined
        min-height="180px"
      > 
        <v-row class="pa-4">
          <v-col cols="12">
            <h3 class="font-weight-regular">Redes:</h3>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              ref="web"
              v-model="web"
              outlined
              label="Web"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              ref="linkedin"
              v-model="linkedin"
              outlined
              label="Linkedin"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              ref="instagram"
              v-model="instagram"
              outlined
              label="Instagram"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              ref="facebook"
              v-model="facebook"
              outlined
              label="Facebook"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              ref="twitter"
              v-model="twitter"
              outlined
              label="Twitter"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              ref="youtube"
              v-model="youtube"
              outlined
              label="Youtube"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              ref="whatsapp"
              v-model="whatsapp"
              outlined
              label="Whatsapp"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              ref="email"
              v-model="email"
              outlined
              label="Correo Electrónico"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-sheet>

      <v-sheet
        class="mt-4"
        width="100%"
        outlined
        min-height="180px"
      > 
        <v-row class="pa-4">
          <v-col cols="12">
            <h3 class="font-weight-regular">Foto perfíl:</h3>
          </v-col>
          
          <v-col cols="12">
            <v-file-input
              outlined
              v-if="!photo"
              v-model="photo"
              :rules="rules"
              @change="onPhotoChange"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Foto"
              :messages="['Para una mejor visualización, usar un foto cuadrado, màximo de 480x480px, y sí tiene transparencia asegurarse de que sea formato PNG.']"
            ></v-file-input>

            <v-card
              max-width="380px"
              v-if="photo"
              wei>
              <v-img
                contain
                :src="url_photo"
                class="grey lighten-2"
                height="240px"
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deletePhoto()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'juriesEdition', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_btn"
        color="primary"
        @click="updateJury()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Actualizar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="error"
      persistent
      max-width="480"
    >
      <v-card>
        <v-card-title class="text-h5">
          Advertencia
        </v-card-title>
        <v-card-text>
    
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title 
                v-for="error in errors" 
                v-bind:key="error"
                style="white-space: normal; word-break: break-word;"
                class="pt-2">
                - {{ error }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="error = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>
<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'newSpeakersEdition',

    data: () => ({
      loading:true,
      loading_btn: false,
      loading_update:false,

      speaker:[],
      name: null,
      last_position:null,
      description: null,
      web: null,
      linkedin: null,
      instagram: null,
      facebook: null,
      twitter: null,
      youtube: null,
      whatsapp: null,
      email: null,

      photo:null,
      url_photo:null,

      countries:[],
      country_id: null,

      rules: [
        (value) =>
          !value ||
          value.size < 2 ||
          "El archivo es demaciado grande",
      ],

      edition_id: null,
      jury_id: null,

      error:false,
      errors:[],
    }),

    methods:{
      async getCountries()
      {
        await axios.get('admin/countries').then(response =>{
          this.countries = response.data.data.countries
        }).catch(error => {
          console.log(error);
        })
      },

      async getJuryEdition(){
        await axios.get('admin/editions/'+this.edition_id+'/juries/'+this.jury_id).then(response =>{
          this.jury = response.data.data.jury
          
          this.name = this.jury.name
          this.country_id = this.jury.country_id
          this.last_position = this.jury.last_position
          this.description = this.jury.description
          this.web = this.jury.web
          this.linkedin = this.jury.linkedin
          this.instagram = this.jury.instagram
          this.facebook = this.jury.facebook
          this.twitter = this.jury.twitter
          this.youtube = this.jury.youtube
          this.whatsapp = this.jury.whatsapp
          this.email = this.jury.email

          this.photo = this.jury.photo
          this.url_photo = APP_URL+ this.photo

          this.loading=false
          this.show=true
        }).catch(error => {
          console.log(error);
        })
      },

      async updateJury()
      {
        this.loading_btn = true

        let formData= new FormData()

        if(this.name){
          formData.append('name', this.name);
        }

        formData.append('country_id', this.country_id)

        if(this.last_position!=null){
          formData.append('last_position', this.last_position);
        }

        if(this.description!=null){
          formData.append('description', this.description);
        }

        if(this.web!=null){
          formData.append('web', this.web);
        }

        if(this.linkedin!=null){
          formData.append('linkedin', this.linkedin);
        }

        if(this.instagram!=null){
          formData.append('instagram', this.instagram);
        }

        if(this.facebook!=null){
          formData.append('facebook', this.facebook);
        }

        if(this.twitter!=null){
          formData.append('twitter', this.twitter);
        }

        if(this.youtube!=null){
          formData.append('youtube', this.youtube);
        }

        if(this.whatsapp!=null){
          formData.append('whatsapp', this.whatsapp);
        }

        if(this.email!=null){
          formData.append('email', this.email);
        }

        if(this.photo!=null){
          formData.append('photo', this.photo);
        }
        try {
          await axios({
            method: 'post',
            url: 'admin/editions/'+this.edition_id+'/juries/'+this.jury_id,
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.dialog_new = false
            this.loading_btn = false
            this.loading = true
            this.$router.push({ name: 'juriesEdition', params: { edition_id: this.edition_id } })
          })
        } catch (error) {
          this.loading_btn=false
          this.errors = Object.values(error.response.data.errors).flat()
          this.error = true
        }
      },

      onPhotoChange() {
        this.url_photo = URL.createObjectURL(this.photo);
      },

      deletePhoto(){
        this.photo=null
        this.url_photo=null
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id
      this.jury_id = this.$route.params.jury_id
      this.getCountries().then(
        this.getJuryEdition()
      )
    },
  }
</script>
